import { useAppView } from '../../../contexts/AppViewContext';
import clsx from 'clsx';
import React from 'react';

export const SectorToggle = () => {
  const appView = useAppView();

  return (
    <div className="p-2 w-full border-x-2 border-background-dark">
      <div className="flex items-center gap-2 p-1 bg-background-dark rounded text-xs">
        <button
          className={clsx('px-3 py-1 w-full rounded hover:opacity-70', {
            'bg-primary/20 pointer-events-none':
              appView.pending.sector === 'Hospitality',
          })}
          onClick={() => appView.changePendingView({ sector: 'Hospitality' })}
          type="button"
        >
          Hospitality
        </button>
        <button
          className={clsx('px-3 py-1 w-full rounded hover:opacity-70', {
            'bg-primary/20 pointer-events-none':
              appView.pending.sector === 'Residential',
          })}
          onClick={() => appView.changePendingView({ sector: 'Residential' })}
          type="button"
        >
          Residential
        </button>
      </div>
    </div>
  );
};
